module.exports = __webpack_public_path__ + "static/media/ic_tab_live.d1d0d629.png";